import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-85924f48")

_pushScopeId("data-v-85924f48")
const _hoisted_1 = { class: "reportInfo" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "实验报告", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "—", -1)
const _hoisted_5 = {
  class: "b-main",
  id: "m-body"
}
const _hoisted_6 = { class: "exportBtn" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "title" }, "实训报告", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")
  const _component_a_button = _resolveComponent("a-button")
  const _component_ManagementFrame = _resolveComponent("ManagementFrame")
  const _directive_print = _resolveDirective("print")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_ManagementFrame, null, {
      title: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createVNode("span", null, _toDisplayString(_ctx.experimentName), 1)
        ])
      ]),
      controllers: _withId(() => [
        _createVNode(_component_SvgIcon, {
          class: "fs22 pointer",
          icon: "back",
          onClick: _ctx.back
        }, null, 8, ["onClick"])
      ]),
      content: _withId(() => [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _withDirectives(_createVNode(_component_a_button, { type: "primary" }, {
              default: _withId(() => [
                _hoisted_7
              ]),
              _: 1
            }, 512), [
              [_directive_print, _ctx.printObj]
            ])
          ]),
          _hoisted_8,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.componentList, (com) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(com.name), {
              key: com.uuid,
              data: com.data
            }, null, 8, ["data"]))
          }), 128))
        ])
      ]),
      _: 1
    })
  ]))
})